import { redirect } from '@tanstack/react-router'
import { getAccessToken, silentRefresh } from './api'
import { type AuthUser, getAuthUser } from './auth'
import { getHomeRoute } from './roles'

/**
 * Garde commune aux layouts d'espace, sur le patron de
 * front-end/src/routes/_app/route.tsx.
 *
 * `expected` est la route d'accueil de l'espace : si `getHomeRoute()` ne
 * renvoie pas la même, l'utilisateur n'a rien à faire ici et on le redirige
 * vers son propre espace (plutôt que de rendre `null` en silence comme le
 * fait l'app native).
 */
export async function requireSpace(expected: string): Promise<AuthUser> {
  // Après un rechargement l'access token en mémoire est vide : on tente de le
  // restaurer depuis le cookie HttpOnly avant de conclure à une déconnexion.
  if (!getAccessToken()) await silentRefresh()

  const user = getAuthUser()
  if (!user) throw redirect({ to: '/connexion' })

  const home = getHomeRoute(user.roles)
  if (home !== expected) throw redirect({ to: home })

  return user
}

/**
 * Garde de route enfant : vérifie une permission fine et renvoie à l'accueil
 * de l'espace si elle manque. Évite d'afficher un écran qui ne ferait que des 403.
 */
export function requirePermission(
  user: AuthUser,
  allowed: (roles: string[]) => boolean,
  fallback: string,
) {
  if (!allowed(user.roles)) throw redirect({ to: fallback })
}
